module.exports = __webpack_public_path__ + "static/media/18-apr23jun23.1b2e99bc.pdf";